import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../utils/store';

export interface GlobalUserAccessRoles {
  has_visited_program_settings: boolean,
  has_visited_report_form_settings: boolean,
  has_visited_user_settings: boolean,
  is_email_notification_enabled: boolean;
  is_allowed_to_reopen_report: boolean;
  is_allowed_to_request_pii_removal: boolean;
  is_allowed_to_redact_report: boolean;
  is_read_only_report: boolean;
  is_allowed_to_create_final_report_template: boolean;
  is_allowed_to_download_final_report: boolean;
  is_allowed_to_download_attachments: boolean;
  is_totp_enabled: boolean;
  language_id: number;
}

const initialState: GlobalUserAccessRoles = {
  has_visited_program_settings: false,
  has_visited_report_form_settings: false,
  has_visited_user_settings: false,
  is_email_notification_enabled: false,
  is_allowed_to_reopen_report: false,
  is_allowed_to_request_pii_removal: false,
  is_allowed_to_redact_report: false,
  is_read_only_report: false,
  is_allowed_to_create_final_report_template: false,
  is_allowed_to_download_final_report: false,
  is_allowed_to_download_attachments: false,
  is_totp_enabled: false,
  language_id: 0,
};

export const userRoleSlice = createSlice({
  name: 'userRoles',
  initialState,
  reducers: {
    setRoles: (_, action: PayloadAction<GlobalUserAccessRoles>) => {
      return action.payload;
    },
  },
});

export const { setRoles } = userRoleSlice.actions;

export const selectRoles = (state: RootState) => state.userRoles;

export default userRoleSlice.reducer;
